import React, { useState, useEffect } from 'react';

const ScrollButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 50) { 
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="fixed z-[100] font-bold text-3xl bottom-4 right-4 bg-[#093067] text-white p-3 w-16 h-16 rounded-full shadow-xl hover:bg-[#093067e5] transition-all duration-300"
                >
                    ↑
                </button>
            )}
        </div>
    );
};

export default ScrollButton;
